import F84Game from "../Game";
import GameConfig from "../core/data/GameConfig";
import BaseURL from "../utils/BaseURL";
import LoadingContainer, { LoadingContainerState } from "../ui/LoadingContainer";
import Fonts from "../utils/Fonts";
import LoaderScene from "./LoaderScene";
import ScreenTransition from "./ScreenTransition";

export default class PreloaderScene extends LoaderScene {
    private _onResize: () => any;
    loadingContainerState?: LoadingContainerState;
    private _loadingContainer: LoadingContainer;
    private destinationScene: string;

    init(data: { destinationScene: string, loadingContainerState?: LoadingContainerState }): void {
        this.destinationScene = "SplashScene";
        if (data.destinationScene) this.destinationScene = data.destinationScene;
        this.loadingContainerState = data.loadingContainerState;
        super.init(data);
    }

    public preload(): void {
        super.preload();

        this._loadingContainer = new LoadingContainer(this, (this.loadingContainerState == null), true, this.loadingContainerState);
        this.add.existing(this._loadingContainer);

        this.load.setBaseURL(BaseURL.getBaseURL());

        // this.load.webfont(Fonts.DefaultFont, Fonts.DefaultFont);

        F84Game.Instance.loadBatches.loadBatchesForScene(this, this.destinationScene);
        this.loadUpdate();
    }

    create(): void {
        super.create();
        this.next();
    }

    loadUpdate(): void {
        const percentComplete = this.load.totalComplete / this.load.totalToLoad;
        this._loadingContainer.setLoadPercent(percentComplete);
    }

    resize(): void {
        super.resize();
        if (this._onResize != null) this._onResize();
    }

    onLoadComplete(): void {
        if (this._loadingContainer) this._loadingContainer.setLoadComplete();
        this.resize();
    }

    next(): void {
        GameConfig.loadConfigFile(this.cache, "gameConfig");
        if(this.destinationScene != "SplashScene"){
            ScreenTransition.to(this, this.destinationScene, {transitioned: true});
        }  
        else {
            this._loadingContainer.buildComplete.then(() => {
                this._loadingContainer.tweenOutMeter(() => {
                    this.scene.start(this.destinationScene, this._loadingContainer.containerState);
                    this.scene.stop(this.scene.key);
                });
            });
        }
    }

    shutdown(): void {
        this._onResize = null;
        this._loadingContainer = null;
        super.shutdown();
    }
}
